import React from "react";

import { Col, Row, Layout as LayoutBase } from "antd";
import "./styles.scss";
const { Content } = LayoutBase;

const Component = (WrappedComponent) => {
  const Layout = () => {
    return (
      <LayoutBase className="layout-public-wrapper">
        <Content className="layout-public">
          <Row>
            <Col xs={{ span: 24 }} sm={{ span: 6, offset: 9 }}>
              <WrappedComponent />
            </Col>
          </Row>
        </Content>
      </LayoutBase>
    );
  };
  return Layout;
};

export default Component;
